<template>
  <div
    :class="uiButtonClass"
    class="ui-button"
  >
    <button
      :type="type"
      :disabled="disabled"
      class="button"
      @click="$emit('click')"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: 'UiButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'blue', // blue, green
    },
  },
  computed: {
    uiButtonClass () {
      return [
        `ui-button--${this.theme}`,
      ]
    },
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/variables'

.button
  padding: 9px 23px 11px
  margin-right: 3px
  margin-top: 1px
  border: none
  border-radius: 9in
  outline: none
  cursor: pointer
  font: 500 16px Gilroy, Avenir, system-ui, sans-serif
  letter-spacing: .2px
  text-align: center

.ui-button--blue
  button
    background-color: #365a93
    color: #fff
    border: 2px solid #365a93
    transition: box-shadow .3s, background .3s, color .3s

    &:hover
      background-color: #fff
      color: #365a93

.ui-button--green
  button
    background-color: #43d394
    border-radius: 22px
    color: #fff
    padding: 11px 36px 10px 35px
    letter-spacing: .4px
    margin-top: 28px
    margin-left: 1px
    font: 500 17px $font-family-secondary
    border: 2px solid #43d394
    cursor: pointer
    box-shadow: 0px 5px 7px rgba(73,107,163,0.2)
    transition: background .3s, color .3s

    &:hover
      background-color: #fff
      color: #43d394
</style>



// WEBPACK FOOTER //
// src/components/ui/UiButton.vue